<button
  nz-button
  (click)="exportSharedUserQualificationsComplementaryCertificate()"
>
  {{ 'page.qualifications.export_complementary_certificate' | translate }}
</button>
